import { useInfiniteQuery } from '@tanstack/react-query';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { CoachesListParams } from '@src/api/coaches.ts';
import { API } from '@src/api/index.ts';

export const useCoachesInfiniteQuery = (params: Omit<CoachesListParams, 'page' | 'module'>) => {
  const { moduleId } = useModuleByCodeParam();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['coaches', { ...params, moduleId }],
    queryFn: async ({ pageParam = 1 }) =>
      await API.coaches.getList({
        ...params,
        page: pageParam,
        module: moduleId,
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { next } = lastPage;
      return next ? lastPageParam + 1 : undefined;
    },
    select: (data) => {
      return {
        ...data,
        results: data?.pages.flatMap((page) => page.results),
      };
    },
  });
};
